<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textn"> </p>
<p class="textn"> </p>
<p class="textn">I see that it’s taking all her strength to keep from
  leaping up and helping the waitress clear the table.</p>
<p class="textn">I see how much she wants to run back into the
restaurant’s kitchen and wash the pans.</p>
<p class="textn">I see that she’s worried about the busboy’s tired
arms, the cashier’s tired feet, and that it’s all she can do
to not take the rest of her meal out to that “nice young
man parking the cars.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom006.vue?6208b804